import Client from '../../shared/helpers/api/Client';
import Attendees from './api/Attendees';
import CheckIn from './api/CheckIn';
import Countries from './api/Countries';
import Feedback from './api/Feedback';
import LobbyAvailability from './api/LobbyAvailability';
import Locations from './api/Locations';
import MeetingMethods from './api/MeetingMethods';
import { QrCode } from './api/QrCode';
import Regions from './api/Regions';
import ReserveWithGoogleConversion from './api/ReserveWithGoogleConversion';
import Services from './api/Services';
import SupportedLanguages from './api/SupportedLanguages';
import Timezone from './api/Timezone';
import Users from './api/Users';
import VerifiedFiles from './api/VerifiedFiles';
import WaitTimes from './api/WaitTimes';

const client = Client();
const resources: Record<string, any> = {};

export default {
  attendees(): ReturnType<typeof Attendees> {
    if (!resources.attendees) {
      resources.attendees = Attendees(client);
    }

    return resources.attendees;
  },

  checkIn(): ReturnType<typeof CheckIn> {
    if (!resources.checkIn) {
      resources.checkIn = CheckIn(client);
    }

    return resources.checkIn;
  },

  countries(): ReturnType<typeof Countries> {
    if (!resources.countries) {
      resources.countries = Countries(client);
    }

    return resources.countries;
  },

  feedback(): ReturnType<typeof Feedback> {
    if (!resources.feedback) {
      resources.feedback = Feedback(client);
    }

    return resources.feedback;
  },

  languages(): ReturnType<typeof SupportedLanguages> {
    if (!resources.languages) {
      resources.languages = SupportedLanguages(client);
    }

    return resources.languages;
  },

  locale(locale: string) {
    client.locale(locale);

    return this;
  },

  locations(): ReturnType<typeof Locations> {
    if (!resources.locations) {
      resources.locations = Locations(client);
    }

    return resources.locations;
  },

  methods(): ReturnType<typeof MeetingMethods> {
    if (!resources.methods) {
      resources.methods = MeetingMethods(client);
    }

    return resources.methods;
  },

  qrCode(): ReturnType<typeof QrCode> {
    if (!resources.qrCode) {
      resources.qrCode = QrCode(client);
    }

    return resources.qrCode;
  },

  regions(): ReturnType<typeof Regions> {
    if (!resources.regions) {
      resources.regions = Regions(client);
    }

    return resources.regions;
  },

  services(): ReturnType<typeof Services> {
    if (!resources.services) {
      resources.services = Services(client);
    }

    return resources.services;
  },

  timezone(): Timezone {
    if (!resources.timezone) {
      resources.timezone = new Timezone();
    }

    return resources.timezone;
  },

  users(): ReturnType<typeof Users> {
    if (!resources.users) {
      resources.users = Users(client);
    }

    return resources.users;
  },

  verifiedFiles(): ReturnType<typeof VerifiedFiles> {
    if (!resources.verifiedFiles) {
      resources.verifiedFiles = VerifiedFiles(client);
    }

    return resources.verifiedFiles;
  },

  waitTimes(): ReturnType<typeof WaitTimes> {
    if (!resources.waitTimes) {
      resources.waitTimes = WaitTimes(client);
    }

    return resources.waitTimes;
  },

  lobbyAvailability(): ReturnType<typeof LobbyAvailability> {
    if (!resources.lobbyAvailability) {
      resources.lobbyAvailability = LobbyAvailability(client);
    }

    return resources.lobbyAvailability;
  },

  rwgConversionTracking(): ReturnType<typeof ReserveWithGoogleConversion> {
    if (!resources.rwgConversionTracking) {
      resources.rwgConversionTracking = ReserveWithGoogleConversion(client);
    }

    return resources.rwgConversionTracking;
  },
};
